import HeroSection from './components/HeroSection';
import TrustStrip from './components/TrustStrip';
import ShopByPet from './components/ShopByPet';
import ShopByFunction from './components/ShopByFunction';
import BestsellersCarousel from './components/BestsellersCarousel';
import MaterialStory from './components/MaterialStory';
import BrandPromiseBanner from './components/BrandPromiseBanner';
import InstagramUGC from './components/InstagramUGC';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <div className="bg-background-50">
      <HeroSection />
      <TrustStrip />
      <ShopByPet />
      <ShopByFunction />
      <BestsellersCarousel />
      <BrandPromiseBanner />
      <MaterialStory />
      <InstagramUGC />
      <NewsletterSection />
    </div>
  );
}